import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Chinapana Shankar </span>
            from <span className="purple"> Bengaluru, India.</span>
            <br />
            I am currently student at Kristu Jayanti College, Bengaluru.
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Anime
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "It's stupid to talk about things you're not. Be yourself and you'll be fine."{" "}
          </p>
          <footer className="blockquote-footer">Shikamaru Nara</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
